/**
 * 完整的 Ant Design 图标映射表
 * 包含所有常用的图标名称映射，避免反复出现图标显示问题
 */

export const COMPLETE_ICON_MAPPING: Record<string, string> = {
  // 基础用户相关
  user: 'UserOutlined',
  users: 'UsergroupAddOutlined',
  person: 'UserOutlined',
  people: 'TeamOutlined',
  account: 'UserOutlined',
  profile: 'ProfileOutlined',
  idcard: 'IdcardOutlined',
  identity: 'IdcardOutlined',

  // 设置和配置相关
  setting: 'SettingOutlined',
  settings: 'SettingOutlined',
  config: 'ControlOutlined',
  configuration: 'ControlOutlined',
  control: 'ControlOutlined',
  controls: 'ControlOutlined',
  manage: 'ControlOutlined',
  management: 'ControlOutlined',

  // 团队和组织相关
  team: 'TeamOutlined',
  group: 'GroupOutlined',
  groups: 'GroupOutlined',
  organization: 'ApartmentOutlined',
  organizations: 'ApartmentOutlined',
  org: 'ApartmentOutlined',
  company: 'BankOutlined',
  department: 'BranchesOutlined',
  departments: 'BranchesOutlined',
  dept: 'BranchesOutlined',
  branch: 'BranchesOutlined',
  branches: 'BranchesOutlined',
  position: 'IdcardOutlined',
  positions: 'IdcardOutlined',
  post: 'IdcardOutlined',
  posts: 'IdcardOutlined',

  // 角色和权限相关
  role: 'SafetyCertificateOutlined',
  roles: 'SafetyCertificateOutlined',
  permission: 'KeyOutlined',
  permissions: 'KeyOutlined',
  auth: 'LockOutlined',
  authentication: 'LockOutlined',
  authorize: 'UnlockOutlined',
  authorization: 'UnlockOutlined',
  key: 'KeyOutlined',
  keys: 'KeyOutlined',
  lock: 'LockOutlined',
  locks: 'LockOutlined',
  unlock: 'UnlockOutlined',
  unlocks: 'UnlockOutlined',

  // 系统和菜单相关
  system: 'ControlOutlined',
  systems: 'ControlOutlined',
  menu: 'MenuOutlined',
  menus: 'MenuOutlined',
  navigation: 'MenuOutlined',
  nav: 'MenuOutlined',
  sidebar: 'MenuOutlined',

  // 设备和硬件相关
  device: 'MobileOutlined',
  devices: 'MobileOutlined',
  desktop: 'DesktopOutlined',
  computer: 'DesktopOutlined',
  laptop: 'LaptopOutlined',
  mobile: 'MobileOutlined',
  phone: 'PhoneOutlined',
  phones: 'PhoneOutlined',
  tablet: 'TabletOutlined',
  terminal: 'CodeOutlined',
  terminals: 'CodeOutlined',
  server: 'CloudServerOutlined',
  servers: 'CloudServerOutlined',
  hardware: 'ToolOutlined',

  // 网络和连接相关
  network: 'GlobalOutlined',
  internet: 'GlobalOutlined',
  web: 'GlobalOutlined',
  www: 'GlobalOutlined',
  link: 'LinkOutlined',
  links: 'LinkOutlined',
  unlink: 'DisconnectOutlined',
  disconnect: 'DisconnectOutlined',
  connection: 'LinkOutlined',
  connections: 'LinkOutlined',
  wifi: 'WifiOutlined',
  wireless: 'WifiOutlined',

  // 数据和存储相关
  database: 'DatabaseOutlined',
  databases: 'DatabaseOutlined',
  data: 'DatabaseOutlined',
  storage: 'HddOutlined',
  disk: 'HddOutlined',
  drive: 'HddOutlined',
  cloud: 'CloudOutlined',
  clouds: 'CloudOutlined',
  file: 'FileOutlined',
  files: 'FileOutlined',
  folder: 'FolderOutlined',
  folders: 'FolderOutlined',
  directory: 'FolderOpenOutlined',
  document: 'FileTextOutlined',
  documents: 'FileTextOutlined',

  // API和接口相关
  api: 'ApiOutlined',
  apis: 'ApiOutlined',
  interface: 'ApiOutlined',
  interfaces: 'ApiOutlined',
  endpoint: 'ApiOutlined',
  endpoints: 'ApiOutlined',
  service: 'CloudServerOutlined',
  services: 'CloudServerOutlined',

  // 工具和操作相关
  tool: 'ToolOutlined',
  tools: 'ToolOutlined',
  utility: 'ToolOutlined',
  utilities: 'ToolOutlined',
  edit: 'EditOutlined',
  modify: 'EditOutlined',
  update: 'EditOutlined',
  delete: 'DeleteOutlined',
  remove: 'DeleteOutlined',
  trash: 'DeleteOutlined',
  clear: 'DeleteOutlined',
  plus: 'PlusOutlined',
  add: 'PlusOutlined',
  create: 'PlusOutlined',
  new: 'PlusOutlined',
  minus: 'MinusOutlined',
  subtract: 'MinusOutlined',
  save: 'SaveOutlined',
  download: 'DownloadOutlined',
  upload: 'UploadOutlined',
  import: 'UploadOutlined',
  export: 'DownloadOutlined',

  // 搜索和筛选相关
  search: 'SearchOutlined',
  find: 'SearchOutlined',
  lookup: 'SearchOutlined',
  filter: 'FilterOutlined',
  filters: 'FilterOutlined',
  sort: 'SortAscendingOutlined',
  sorting: 'SortAscendingOutlined',

  // 查看和显示相关
  eye: 'EyeOutlined',
  view: 'EyeOutlined',
  show: 'EyeOutlined',
  display: 'EyeOutlined',
  visible: 'EyeOutlined',
  'eye-invisible': 'EyeInvisibleOutlined',
  hide: 'EyeInvisibleOutlined',
  invisible: 'EyeInvisibleOutlined',
  hidden: 'EyeInvisibleOutlined',

  // 状态和反馈相关
  check: 'CheckOutlined',
  success: 'CheckCircleOutlined',
  correct: 'CheckCircleOutlined',
  ok: 'CheckCircleOutlined',
  close: 'CloseOutlined',
  cancel: 'CloseOutlined',
  error: 'CloseCircleOutlined',
  fail: 'CloseCircleOutlined',
  failure: 'CloseCircleOutlined',
  warning: 'WarningOutlined',
  warn: 'WarningOutlined',
  alert: 'AlertOutlined',
  alerts: 'AlertOutlined',
  info: 'InfoCircleOutlined',
  information: 'InfoCircleOutlined',
  help: 'QuestionCircleOutlined',
  question: 'QuestionCircleOutlined',
  support: 'CustomerServiceOutlined',

  // 时间和日期相关
  time: 'ClockCircleOutlined',
  clock: 'ClockCircleOutlined',
  timer: 'ClockCircleOutlined',
  date: 'CalendarOutlined',
  calendar: 'CalendarOutlined',
  schedule: 'CalendarOutlined',
  scheduling: 'CalendarOutlined',

  // 通信和消息相关
  message: 'MessageOutlined',
  messages: 'MessageOutlined',
  mail: 'MailOutlined',
  email: 'MailOutlined',
  emails: 'MailOutlined',
  notification: 'NotificationOutlined',
  notifications: 'NotificationOutlined',
  bell: 'BellOutlined',
  bells: 'BellOutlined',

  // 媒体和图像相关
  image: 'PictureOutlined',
  images: 'PictureOutlined',
  photo: 'PictureOutlined',
  photos: 'PictureOutlined',
  picture: 'PictureOutlined',
  pictures: 'PictureOutlined',
  video: 'PlaySquareOutlined',
  videos: 'PlaySquareOutlined',
  audio: 'SoundOutlined',
  music: 'CustomerServiceOutlined',

  // 表格和列表相关
  table: 'TableOutlined',
  tables: 'TableOutlined',
  list: 'UnorderedListOutlined',
  lists: 'UnorderedListOutlined',
  grid: 'AppstoreOutlined',
  form: 'FormOutlined',
  forms: 'FormOutlined',

  // 业务模块相关
  package: 'GiftOutlined',
  packages: 'GiftOutlined',
  gift: 'GiftOutlined',
  event: 'CalendarOutlined',
  events: 'CalendarOutlined',
  order: 'ShoppingCartOutlined',
  orders: 'ShoppingCartOutlined',
  cart: 'ShoppingCartOutlined',
  'shopping-cart': 'ShoppingCartOutlined',
  shopping: 'ShoppingCartOutlined',
  business: 'ShopOutlined',
  commerce: 'ShopOutlined',
  trade: 'TransactionOutlined',
  transaction: 'TransactionOutlined',
  transactions: 'TransactionOutlined',

  // 特殊业务图标补充
  gateway: 'GatewayOutlined',
  gateways: 'GatewayOutlined',
  model: 'BuildOutlined',
  models: 'BuildOutlined',
  supplier: 'ShopOutlined',
  suppliers: 'ShopOutlined',
  receiver: 'UserSwitchOutlined',
  receivers: 'UserSwitchOutlined',
  resource: 'FolderOpenOutlined',
  resources: 'FolderOpenOutlined',
  record: 'HistoryOutlined',
  records: 'HistoryOutlined',
  node: 'NodeIndexOutlined',
  nodes: 'NodeIndexOutlined',
  tree: 'PartitionOutlined',
  trees: 'PartitionOutlined',

  // 其他常用图标
  home: 'HomeOutlined',
  house: 'HomeOutlined',
  bookmark: 'BookOutlined',
  bookmarks: 'BookOutlined',
  book: 'BookOutlined',
  books: 'BookOutlined',
  attachment: 'PaperClipOutlined',
  attachments: 'PaperClipOutlined',
  clip: 'PaperClipOutlined',
  global: 'GlobalOutlined',
  world: 'GlobalOutlined',
  earth: 'GlobalOutlined',
  map: 'EnvironmentOutlined',
  location: 'EnvironmentOutlined',
  place: 'EnvironmentOutlined',
  pin: 'PushpinOutlined',
  pushpin: 'PushpinOutlined',
  star: 'StarOutlined',
  stars: 'StarOutlined',
  heart: 'HeartOutlined',
  hearts: 'HeartOutlined',
  like: 'LikeOutlined',
  dislike: 'DislikeOutlined',
  fire: 'FireOutlined',
  flag: 'FlagOutlined',
  flags: 'FlagOutlined',
  tag: 'TagOutlined',
  tags: 'TagsOutlined',
  label: 'TagOutlined',
  labels: 'TagsOutlined',
  barcode: 'BarcodeOutlined',
  qrcode: 'QrcodeOutlined',
  scan: 'ScanOutlined',
  printer: 'PrinterOutlined',
  print: 'PrinterOutlined',
  camera: 'CameraOutlined',
  cameras: 'CameraOutlined',
  calculator: 'CalculatorOutlined',
};

/**
 * 获取完整的图标映射表
 */
export const getCompleteIconMapping = (): Record<string, string> => {
  return { ...COMPLETE_ICON_MAPPING };
};

/**
 * 检查图标名称是否存在于完整映射表中
 */
export const hasIconMapping = (iconName: string): boolean => {
  if (!iconName || typeof iconName !== 'string') return false;
  const cleanName = iconName.replace(/['"]/g, '').trim().toLowerCase();
  return cleanName in COMPLETE_ICON_MAPPING;
};

/**
 * 获取图标的标准名称
 */
export const getStandardIconName = (iconName: string): string => {
  if (!iconName || typeof iconName !== 'string') return '';
  const cleanName = iconName.replace(/['"]/g, '').trim().toLowerCase();
  return COMPLETE_ICON_MAPPING[cleanName] || iconName;
};
